import API from "../../models/API";
import { TransformRule } from "../../models/transformation/TransformRule";

export { TransformRuleTester };

class TransformRuleTester {
  acceleratorDocUuid: undefined | string;
  rules: TransformRule[];
  /**
   * Expect key to not contain $$ prefix
   */
  dlfVariables: { [key in string]: string };
  /**
   * Expect key to contain %% prefix
   */
  variables: { [key in string]: string };

  constructor(
    acceleratorDocUuid: any,
    //
    rules: TransformRule[],
    // all transform dlf variable values
    dlfVariables: TransformRuleTester["dlfVariables"],
    // all editable transform variable values
    variables: TransformRuleTester["variables"],
  ) {
    this.acceleratorDocUuid = acceleratorDocUuid;
    this.rules = rules;
    this.dlfVariables = dlfVariables;
    this.variables = { ...variables, "%%COUNTER": "1" };
  }

  async transform(startValue: string): Promise<string[] | undefined> {
    return await API.post(
      `/v0/transform/test`,
      { startValue: encodeURIComponent(startValue) },
      {
        docUuid: this.acceleratorDocUuid,
        rules: this.rules,
        dlfVariables: this.dlfVariables,
        variables: this.variables,
      },
    )
      .then((value: Response) => value.json())
      .then((value: any): string[] | undefined => {
        if (Array.isArray(value)) {
          return value;
        }
        return undefined;
      })
      .catch((error: string) => {
        console.log(error);
        return undefined;
      });
  }
}
